import { render, staticRenderFns } from "./QuadroViagens.vue?vue&type=template&id=09588dbd&"
import script from "./QuadroViagens.vue?vue&type=script&lang=js&"
export * from "./QuadroViagens.vue?vue&type=script&lang=js&"
import style0 from "./QuadroViagens.vue?vue&type=style&index=0&id=09588dbd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports